<!-- <div class="list">
    <ul>
        <li *ngFor="
          let item of collection
            | paginate
              : { itemsPerPage: this.itemsPerPage, currentPage: this.currentPage }
        ">
            {{ item }}
        </li>
    </ul>
</div> -->

<!-- <ul class="pagination pmd-pagination pmd-pagination-outline mb-0">
    <li class="page-item pagination-arrow">
        <a class="page-link disabled" href="javascript:void(0);" aria-label="Previous">
            <i class="material-icons pmd-xs">chevron_left</i>
        </a>
    </li>
    <li class="page-item"><a class="page-link pmd-ripple-effect" href="javascript:void(0);">1</a></li>
    <li class="page-item active"><a class="page-link pmd-ripple-effect" href="javascript:void(0);">2</a></li>
    <li class="page-item"><a class="page-link pmd-ripple-effect" href="javascript:void(0);">3</a></li>
    <li class="page-item"><a class="page-link pmd-ripple-effect disabled" href="javascript:void(0);">...</a></li>
    <li class="page-item"><a class="page-link pmd-ripple-effect" href="javascript:void(0);">12</a></li>
    <li class="page-item"><a class="page-link pmd-ripple-effect" href="javascript:void(0);">14</a></li>
    <li class="page-item"><a class="page-link pmd-ripple-effect" href="javascript:void(0);">15</a></li>
    <li class="page-item pagination-arrow">
        <a class="page-link pmd-ripple-effect" href="javascript:void(0);" aria-label="Next">
            <i class="material-icons pmd-xs">chevron_right</i>
        </a>
    </li>
</ul> -->

<pagination-template #p="paginationApi" [id]="id" [maxSize]="maxSize" (pageChange)="pageChange.emit($event)"
    (pageBoundsCorrection)="pageBoundsCorrection.emit($event)">
    <ul class="ngx-pagination pagination pmd-pagination pmd-pagination-outline mb-0" [attr.aria-label]="screenReaderPaginationLabel" [class.responsive]="responsive"
        *ngIf="!(autoHide && p.pages.length <= 1)">
        <li class="pagination-previous page-item pagination-arrow" [class.disabled]="p.isFirstPage()" *ngIf="directionLinks">
            <a class="page-link pmd-ripple-effect" tabindex="0" *ngIf="1 < p.getCurrent()" (keyup.enter)="p.previous()" (click)="p.previous()"
                [attr.aria-label]="previousLabel + ' ' + screenReaderPageLabel">
                <i class="material-icons pmd-xs">chevron_left</i>
                <span class="show-for-sr"></span>
            </a>
            
                <a *ngIf="p.isFirstPage()" class="page-link pmd-ripple-effect" tabindex="0" 
                [attr.aria-label]="previousLabel + ' ' + screenReaderPageLabel">
                <i class="material-icons pmd-xs">chevron_left</i>
                <span class="show-for-sr"></span>
            </a>
                <!-- <i class="material-icons pmd-xs">chevron_left</i> -->
        </li>
        <li class="small-screen">{{ p.getCurrent() }} / {{ p.getLastPage() }}</li>
        <li class="page-item"  [class.ellipsis]="page.label === '...'"
            *ngFor="let page of p.pages; trackBy: trackByIndex">
            <a class="page-link pmd-ripple-effect" tabindex="0" (keyup.enter)="p.setCurrent(page.value)" (click)="p.setCurrent(page.value)"
                *ngIf="p.getCurrent() !== page.value">
                <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
                <span>{{
                    page.label === '...' ? page.label : (page.label | number: '')
                    }}</span>
            </a>
            <ng-container  *ngIf="p.getCurrent() === page.value">
                <a [class.current]="p.getCurrent() === page.value" class="page-link pmd-ripple-effect">
                <span  class="show-for-sr">{{ screenReaderCurrentLabel }} </span>
                <span>{{
                    page.label === '...' ? page.label : (page.label | number: '')
                    }}</span>
                 </a>   
            </ng-container>
        </li>
        <li class="pagination-next page-item pagination-arrow" [class.disabled]="p.isLastPage()" *ngIf="directionLinks">
            <a class="page-link pmd-ripple-effect" tabindex="0" *ngIf="!p.isLastPage()" (keyup.enter)="p.next()" (click)="p.next()"
                [attr.aria-label]="nextLabel + ' ' + screenReaderPageLabel">
                <i class="material-icons pmd-xs">chevron_right</i>
                <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
            </a>
            <a *ngIf="p.isLastPage()" class="page-link pmd-ripple-effect" tabindex="0" 
                [attr.aria-label]="nextLabel + ' ' + screenReaderPageLabel">
                <i class="material-icons pmd-xs">chevron_right</i>
                <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
            </a>
        </li>
    </ul>
</pagination-template>